export enum ActivityTableColumnTitle {
  Date = "Datum akt.",
  Activity = "Aktivnost",
  Channels = "Kanal",
  FirstName = "Ime",
  LastName = "Prezime",
  Program = "Program",
  Action = "Akcija",
}
